import { useEffect } from "react";
import loadBackboneApp from "../../../../app/load-backbone-app";
import { AlertMainLayoutView } from "../../../../app/components/alertmanager/alertmanager";
import api from "../../../..//core/api/api";
import metaStoreService from "../../../../core/services/metaStoreService/meta-store-service";
import Backbone from "backbone";
import AlertManagerRoot from "../alert-manager-root";
import { isUserAdmin } from "../../../../core/user-management/update.control";

function AddNewAlert() {
    const isAdmin = isUserAdmin();

    useEffect(() => {
        const safeCall = (promise) => Promise.resolve(promise).catch(() => null);
        const promises = [
            metaStoreService.fetchCollection(metaStoreService.entities.SYSALERTRULE),
            safeCall(api.getEmailConfigStatus()),
            safeCall(api.getSlackConfigStatus()),
            safeCall(api.getTeamsConfigStatus())
        ];

        Promise.all(promises).then(results => {
            const [alertCollection, emailConfigStatus, slackConfigStatus, teamsConfigStatus] = results;
            const pageModel = new Backbone.Model({
                tab: "smart_alerts",
                showNew: true,
                category: null,
                item: null,
                isLiteMode: false,
                isAdmin: isAdmin,
                alertCollection: alertCollection,
                emailConfigStatus: emailConfigStatus || null,
                slackConfigStatus: slackConfigStatus || null,
                teamsConfigStatus: teamsConfigStatus || null
            });
            // @ts-ignore
            loadBackboneApp(new AlertMainLayoutView({ model: pageModel }));
        });
    }, []);

    return <></>;
}

export default function() {
    return (
        <AlertManagerRoot>
            <AddNewAlert />
        </AlertManagerRoot>
    );
}
